import { ConnectResult, createPromiseClient } from '@/connect';
import {
  ListCompanyReportsResponse,
  ReportingService,
} from '@/connect/gen/modules/apiengine/services/reporting/reporting_pb';

export const reportingService = new (class {
  public readonly promiseClient = createPromiseClient(ReportingService);

  public async listCompanyReports(
    companyId: string
  ): Promise<ConnectResult<ListCompanyReportsResponse>> {
    const result = await this.promiseClient.listCompanyReports({ companyId });
    return result as ConnectResult<ListCompanyReportsResponse>;
  }
})();
